import { useState } from "react";
import { Link } from "react-router";
import GetApp from "~/components/common/GetApp";
import TrustpilotWidget from "~/components/common/TrustpilotWidget";
import blogImg from "~/assets/deal-feed/blog_01.png";
import subsidyImg from "~/assets/deal-feed/shoes.png";
import shareImg from "~/assets/deal-feed/share.svg";
import { trackDownloadSelect } from "~/lib/track-events";

const BLOG_URL = "https://blog.blidz.com/blidz-just-got-better-heres-how/";

export default function Sidebar() {
  const [getAppOpen, setGetAppOpen] = useState(false);

  return (
    <>
      <div className="flex flex-col items-start gap-6">
        {/* Blog image card */}
        <Link
          id="deal-feeds-sidebar-blog"
          to={BLOG_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="block w-full cursor-pointer overflow-hidden rounded-3xl"
        >
          <img src={blogImg} alt="Blidz blog" className="w-full rounded-3xl" />
        </Link>

        {/* Trustpilot Mini */}
        <div className="flex w-full items-center justify-center overflow-hidden rounded-3xl border border-gray-200 bg-white p-4">
          <TrustpilotWidget
            templateId="53aa8807dec7e10d38f59f32"
            height="90px"
            width="168px"
            token="2f0a895d-995b-4f3c-b8c5-bcbb0ea2eb73"
          />
        </div>

        <SidebarSubsidy />
        <SidebarInvite
          onClick={() => {
            trackDownloadSelect();
            setGetAppOpen(true);
          }}
        />
      </div>
      <GetApp open={getAppOpen} onOpenChange={setGetAppOpen} />
    </>
  );
}

function SidebarSubsidy() {
  return (
    <Link
      id="deal-feeds-sidebar-subsidy"
      to="/shop/subsidy-program"
      className="flex h-[300px] w-full cursor-pointer flex-col items-start justify-between overflow-hidden rounded-3xl p-6"
      style={{
        background: `
          radial-gradient(83.5% 83.5% at 11.25% 10.5%, #C3ECFF 0%, #C3ECFF 47.22%, rgba(77, 200, 255, 0) 86.65%),
          radial-gradient(89% 89% at 90.75% 32%, #4DC8FF 0%, #FFFEF7 100%),
          linear-gradient(0deg, #FFFFFF, #FFFFFF)
        `,
      }}
    >
      <div className="h-[98px] w-[111px] shrink-0">
        <img src={subsidyImg} alt="subsidy" className="size-full" />
      </div>

      <div className="flex shrink-0 flex-col items-start gap-2">
        <div className="flex w-52 shrink-0 flex-col items-start gap-0.5">
          <p className="w-full text-2xl leading-7 font-bold tracking-[-0.144px] text-neutral-900">Brand Deals</p>
          <p className="text-sm leading-5 font-medium text-neutral-900">Best offers on premium brands</p>
        </div>

        <div className="flex h-9 items-center justify-center gap-1 rounded-xl border border-white/5 bg-[#111] px-3 py-2 hover:opacity-90">
          <span className="text-sm leading-5 font-semibold text-white">View more</span>
        </div>
      </div>
    </Link>
  );
}

function SidebarInvite({ onClick }: { onClick: () => void }) {
  return (
    <div
      id="sidebar-invite-get-app"
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={e => e.key === "Enter" && onClick()}
      className="flex h-[300px] w-full cursor-pointer flex-col items-start justify-between overflow-hidden rounded-3xl bg-gradient-to-l from-[#FFC1AC] to-[#FFE9D8] p-6"
    >
      <div className="size-[72px] shrink-0 overflow-hidden">
        <img src={shareImg} alt="referral" className="size-full" />
      </div>

      <div className="flex shrink-0 flex-col items-start gap-2">
        <div className="flex w-52 shrink-0 flex-col items-start gap-0.5">
          <p className="w-full text-2xl leading-7 font-bold tracking-[-0.144px] text-neutral-900">
            Invite friends to Blidz
          </p>
          <p className="text-sm leading-5 font-medium text-neutral-900">Team-Buy for both!</p>
        </div>

        <div className="flex h-9 items-center justify-center gap-1 rounded-xl border border-white/5 bg-[#111] px-3 py-2 hover:opacity-90">
          <span className="text-sm leading-5 font-semibold text-white">Invite Now</span>
        </div>
      </div>
    </div>
  );
}
